import React from 'react'
import {
  LockOutlined,
  MobileOutlined,
  SecurityScanOutlined,
  ExclamationCircleOutlined,
  ShareAltOutlined,
  DeleteOutlined,
  SettingOutlined,
  UserOutlined,
  ImportOutlined,
  BellOutlined,
  FolderOutlined,
  MailOutlined,
  TeamOutlined,
  CreditCardOutlined,
  GiftOutlined,
  StarOutlined,
  BookOutlined,
  WarningOutlined
} from '@ant-design/icons'

import keys from './keys'
import constants from './constants'

export default {
  ADMIN_MENUS: [
    {
      key: keys.ADMIN_ERROR,
      parent: keys.ERROR,
      icon: <ExclamationCircleOutlined />,
      label: 'common.error',
    },
    {
      key: keys.INVENTORY,
      router: keys.VAULT,
      icon: <LockOutlined />,
      label: 'sidebar.inventory',
    },
    {
      key: keys.VAULT,
      label: 'sidebar.all',
      parent: keys.INVENTORY,
      isChildren: true
    },
    {
      key: keys.PASSWORDS,
      label: 'sidebar.passwords',
      parent: keys.INVENTORY,
      isChildren: true
    },
    {
      key: keys.NOTES,
      label: 'sidebar.notes',
      parent: keys.INVENTORY,
      isChildren: true
    },
    {
      key: keys.CARDS,
      label: 'sidebar.cards',
      parent: keys.INVENTORY,
      isChildren: true
    },
    {
      key: keys.CRYPTO_BACKUPS,
      label: 'sidebar.crypto_backups',
      parent: keys.INVENTORY,
      isChildren: true
    },
    {
      key: keys.IDENTITIES,
      label: 'sidebar.identities',
      parent: keys.INVENTORY,
      isChildren: true
    },
    {
      key: keys.FOLDERS,
      icon: <FolderOutlined />,
      label: 'sidebar.folders',
    },
    {
      key: keys.AUTHENTICATOR,
      icon: <MobileOutlined />,
      label: 'sidebar.authenticator',
    },

    {
      key: keys.SHARES,
      router: keys.SHARED_WITH_ME,
      icon: <ShareAltOutlined />,
      label: 'sidebar.shares',
      className: 'sidebar-shares'
    },
    {
      key: keys.SHARED_WITH_ME,
      label: 'sidebar.shared_with_me',
      parent: keys.SHARES,
      isChildren: true
    },
    {
      key: keys.MY_SHARED_ITEMS,
      label: 'sidebar.my_shared_items',
      parent: keys.SHARES,
      isChildren: true
    },
    {
      key: keys.PRIVATE_EMAIL,
      icon: <MailOutlined />,
      label: 'sidebar.private_email',
    },
    {
      key: keys.SECURITY_TOOLS,
      icon: <SecurityScanOutlined />,
      label: 'sidebar.security_tools',
      className: 'sidebar-security-tool'
    },
    {
      key: keys.SCAM_CHECKER,
      router: keys.CHECK_SCAM,
      icon: <WarningOutlined />,
      label: 'sidebar.scam_checker',
      country: 'VN'
    },
    {
      key: keys.CHECK_SCAM,
      label: 'sidebar.check_scam',
      parent: keys.SCAM_CHECKER,
      isChildren: true,
      country: 'VN'
    },
    {
      key: keys.SCAM_MY_REPORT,
      label: 'sidebar.scam_my_report',
      parent: keys.SCAM_CHECKER,
      isChildren: true,
      country: 'VN'
    },
    {
      key: keys.SCAM_SETTING,
      label: 'sidebar.scam_setting',
      parent: keys.SCAM_CHECKER,
      isChildren: true,
      country: 'VN'
    },
    {
      key: keys.POLICIES,
      icon: <BookOutlined />,
      label: 'policies.title',
      userTypes: [
        constants.USER_TYPE.ENTERPRISE
      ],
    },
    {
      key: keys.SETTINGS,
      icon: <SettingOutlined />,
      router: keys.SETTINGS_ACCOUNT,
      label: 'sidebar.settings',
      className: 'sidebar-settings'
    },
    {
      key: keys.SETTINGS_ACCOUNT,
      parent: keys.SETTINGS,
      icon: <UserOutlined />,
      label: 'sidebar.account',
    },
    {
      key: keys.SETTINGS_MEMBERS,
      parent: keys.SETTINGS,
      icon: <TeamOutlined />,
      label: 'sidebar.manage_members',
      plans: [
        constants.PLANS.FAMILY,
        constants.PLANS.LIFETIME_FAMILY,
        constants.PLANS.LIFETIME_TEAM
      ],
    },
    {
      key: keys.SETTINGS_IMPORT_EXPORT,
      parent: keys.SETTINGS,
      icon: <ImportOutlined />,
      label: 'sidebar.import_export',
    },
    {
      key: keys.SETTINGS_SECURITY,
      parent: keys.SETTINGS,
      icon: <SecurityScanOutlined />,
      label: 'sidebar.security',
    },
    {
      key: keys.SETTINGS_PLANS_BILLING,
      parent: keys.SETTINGS,
      icon: <CreditCardOutlined />,
      label: 'sidebar.plans_billing',
      userTypes: [
        constants.USER_TYPE.PERSONAL
      ],
    },
    {
      key: keys.SETTINGS_NOTIFICATIONS,
      parent: keys.SETTINGS,
      icon: <BellOutlined />,
      label: 'sidebar.notifications',
    },
    {
      key: keys.REWARDS,
      icon: <GiftOutlined />,
      label: 'sidebar.rewards',
      plans: [
        constants.PLANS.FREE,
        constants.PLANS.PREMIUM,
        constants.PLANS.FAMILY
      ],
      userTypes: [
        constants.USER_TYPE.PERSONAL
      ],
    },
    {
      key: keys.MANAGE_PLANS,
      icon: <StarOutlined />,
      label: 'sidebar.manage_plans',
      plans: [
        constants.PLANS.FREE,
      ],
      userTypes: [
        constants.USER_TYPE.PERSONAL
      ],
    },
    {
      key: keys.TRASH,
      icon: <DeleteOutlined />,
      label: 'sidebar.trash',
    },
  ]
} 
